import type { TabsProps } from 'antd';
import type { TruckClass, DocumentType } from '../reference-data/reference-data.api';
import { TruckDetailsTab } from './TruckDetailsTab';
import { TruckDocuments } from './TruckDocuments';
import { TruckHistoryTab } from './TruckHistoryTab';
import { TruckOwnershipTab } from './TruckOwnershipTab';
import type { TruckDetail } from './trucks.api';
import type { useTruckDetail } from './use-truck-detail';

interface BuildTruckDetailTabsArgs {
  truck: TruckDetail;
  truckClasses: TruckClass[];
  documentTypes: DocumentType[];
  canManageTruck: boolean;
  canManageDocuments: boolean;
  detail: ReturnType<typeof useTruckDetail>;
}

/** The four tabs of a truck's own page — its own function so `TruckDetailPage` stays a thin state-to-props wire-up. */
export function buildTruckDetailTabs({
  truck,
  truckClasses,
  documentTypes,
  canManageTruck,
  canManageDocuments,
  detail,
}: BuildTruckDetailTabsArgs): TabsProps['items'] {
  return [
    {
      key: 'details',
      label: 'Details',
      children: (
        <TruckDetailsTab
          truck={truck}
          truckClasses={truckClasses}
          canManage={canManageTruck}
          error={detail.updateError}
          saving={detail.saving}
          onSave={detail.update}
          onRecordReading={detail.recordReading}
        />
      ),
    },
    {
      key: 'documents',
      label: 'Documents',
      children: (
        <TruckDocuments
          documents={truck.documents}
          documentTypes={documentTypes}
          canManage={canManageDocuments}
          submitting={detail.documentSubmitting}
          onAdd={detail.addDocument}
          onEdit={detail.editDocument}
          onRemove={detail.removeDocument}
          onOpen={detail.openDocument}
        />
      ),
    },
    {
      key: 'ownership',
      label: 'Ownership',
      children: <TruckOwnershipTab truckId={truck.id} truckRegistration={truck.registration} canManage={canManageTruck} />,
    },
    { key: 'history', label: 'History', children: <TruckHistoryTab truckId={truck.id} statusHistory={truck.statusHistory} /> },
  ];
}
